import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Pergunta } from 'unb-questionario-componente';
import { QuestionarioDinamicoService } from 'unb-questionario-componente';
import { ValidacaoService } from './validacao.service';
import { Validacao } from './validacao';

@Component({
  selector: 'validacao.dialog',
  templateUrl: './validacao.dialog.html'
})
export class ValidacaoDialog {
  private pergunta: Pergunta;
  private isLoading: boolean;
  private validacao: Validacao;

  constructor(
    public dialogRef: MatDialogRef<ValidacaoDialog>,
    public questionarioService: QuestionarioDinamicoService,
    public validacaoService: ValidacaoService,
    @Inject(MAT_DIALOG_DATA) public validacaoOutCome: Validacao) {
      this.isLoading = true;
      this.validacao = validacaoOutCome;
      if(!this.validacao.id){
        // se não tiver id, então eh uma nova. Ai jah seto o corrido = GrupoFamiliarService
        this.validacao.corrigido = false;
      }
      this.questionarioService.recuperaPerguntaFromIdPergunta(this.validacao.codigoPergunta).subscribe((result: Pergunta)=>{
        this.pergunta = result;
        this.isLoading = false;
      });
    }


  salvar(): void {
      this.dialogRef.close(true);
  }

  fechar(): void {
      this.dialogRef.close(false);
    }


    // mostra erros na tela
  private erro(erro: string){
       this.isLoading = false;
   }

   // finaliza o subscribe
  private finaliza(){
     this.isLoading =false;
   }
}
